<template>
  <div class="flex-container">
    <!-- 面包屑 -->
    <div class="flex-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>渠道管理</el-breadcrumb-item>
        <el-breadcrumb-item>渠道列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 搜索表单 -->
    <el-form
      class="search-form"
      size="mini"
      :inline="true"
      :model="searchForm"
      style="text-align: left"
    >
      <el-form-item label="渠道搜索:">
        <el-select
          v-model="searchForm.channelId"
          placeholder="请选择渠道"
          clearable
          filterable
          style="width: 300px"
        >
          <el-option
            v-for="item in channelList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="审核状态:">
        <el-select
          v-model="searchForm.auditState"
          placeholder="请选择"
          clearable
          style="width: 140px"
        >
          <el-option
            v-for="item in auditStateList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="时间筛选:">
        <el-select
          v-model="searchForm.timeField"
          placeholder="请选择时间字段"
          clearable
          style="width: 120px"
        >
          <el-option label="创建时间" value="create_time" />
          <el-option label="公示日期" value="publicity_date" />
          <el-option label="提测日期" value="check_date" />
          <el-option label="挂网日期" value="join_date" />
          <el-option label="退出日期" value="exit_date" />
        </el-select>
        <span style="margin: 0 4px; color: #909399;">~</span>
        <el-date-picker
          v-model="searchForm.startTime"
          type="date"
          placeholder="开始日期"
          size="mini"
          value-format="yyyy-MM-dd"
          style="width: 140px"
        />
        <span style="margin: 0 4px; color: #909399;">至</span>
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          placeholder="结束日期"
          size="mini"
          value-format="yyyy-MM-dd"
          style="width: 140px"
        />
      </el-form-item>
      <el-form-item label="经营模式:">
        <el-select v-model="searchForm.saleModel" placeholder="请选择" clearable style="width:140px">
          <el-option value="0" label="线上" />
          <el-option value="1" label="线下" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否公示:">
        <el-select v-model="searchForm.isPublicityDate" placeholder="请选择" clearable style="width:140px">
          <el-option value="0" label="否" />
          <el-option value="1" label="是" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否提测:">
        <el-select v-model="searchForm.isCheckDate" placeholder="请选择" clearable style="width:140px">
          <el-option value="0" label="否" />
          <el-option value="1" label="是" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否挂网:">
        <el-select v-model="searchForm.isJoinDate" placeholder="请选择" clearable style="width:140px">
          <el-option value="0" label="否" />
          <el-option value="1" label="是" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否退出:">
        <el-select v-model="searchForm.isExitDate" placeholder="请选择" clearable style="width:140px">
          <el-option value="0" label="否" />
          <el-option value="1" label="是" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
        <el-button type="primary" @click="exportExcel('1')"><i class="el-icon-download"></i> 公示</el-button>
        <el-button type="primary" @click="exportExcel('2')"><i class="el-icon-download"></i> 通知</el-button>
        <el-button type="primary" @click="exportExcel('3')"><i class="el-icon-download"></i> 全量</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 + 分页 -->
    <div class="flex-item table-wrapper">
      <el-table
        ref="multipleTable"
        v-loading="tableLoading"
        size="small"
        border
        :data="tableData"
        :height="tableHeight"
        style="width: 100%;"
      >
        <el-table-column type="index" align="center" width="60px" label="序号" />
        <el-table-column prop="channelName" align="left" min-width="180px" label="渠道名称" show-overflow-tooltip />
        <el-table-column prop="creditCode" align="center" min-width="160px" label="统一社会信用代码" show-overflow-tooltip />
        <el-table-column prop="saleModel" align="center" width="80px" label="经营模式" />
        <el-table-column prop="auditState" align="center" width="100px" label="渠道状态">
          <template slot-scope="scope">
            <div class="audit-state-group">
              <span :style="{ color: getAuditStateColor(scope.row.auditState) }">
                {{ scope.row.auditState || '-' }}
              </span>
              <el-tooltip
                  v-if="scope.row.auditState === '已驳回'"
                  popper-class="audit-tooltip-popper"
                  effect="light"
                  placement="top"
              >
                <div slot="content" class="audit-tip-plain" v-html="scope.row.auditDesc || ''"></div>
                <i class="el-icon-warning" style="margin-left:4px;color:#E6A23C;cursor:pointer;" />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="publicityDate" align="center" width="100px" label="公示日期" />
        <el-table-column prop="checkDate" align="center" width="100px" label="提测日期" />
        <el-table-column prop="joinDate" align="center" width="100px" label="挂网日期" />
        <el-table-column prop="exitDate" align="center" width="100px" label="退出日期" />
        <el-table-column prop="draftCnt" align="center" width="80px" label="待提交">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.draftCnt > 0 ? '#E6A23C' : '#909399' }">
              {{ scope.row.draftCnt || 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewingCnt" align="center" width="90px" label="审核中">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.reviewingCnt > 0 ? '#409EFF' : '#909399' }">
              {{ scope.row.reviewingCnt || 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="completeCnt" align="center" width="90px" label="已完成">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.completeCnt > 0 ? '#67C23A' : '#909399' }">
              {{ scope.row.completeCnt || 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="totalCnt" align="center" width="80px" label="流程总数">
          <template slot-scope="scope">
            <span>{{ scope.row.totalCnt || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" width="150px" label="创建时间" />
        <el-table-column label="操作" align="center" width="180px" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="handleView(scope.row)"
              type="text"
              size="small"
            >查看</el-button>
            <el-button
              v-if="scope.row.publicityDate && !scope.row.checkDate && !scope.row.exitDate"
              @click.native.prevent="handleCheck(scope.row)"
              type="text"
              size="small"
            >提测检查单</el-button>
            <el-button
              v-if="scope.row.checkDate && !scope.row.exitDate"
              @click.native.prevent="handleResubmitCheck(scope.row)"
              type="text"
              size="small"
            >重提检查单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-bar">
        <el-pagination
          :key="paginationKey"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>

    <!-- 提测检查单弹窗 -->
    <el-dialog
      class="check-dialog"
      title="提测检查单"
      :visible.sync="checkDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" size="small">
        <el-form-item label="检查单日期:" required>
          <el-date-picker
            v-model="checkDate"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"
            style="width:100%"
            :clearable="false"
          />
        </el-form-item>
        <el-form-item label="检查单附件:" required>
          <el-upload
            ref="checkUpload"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :file-list="fileList"
            :limit="1"
            accept=".pdf"
            :disabled="uploadLoading"
          >
            <el-button size="small" type="primary" :disabled="uploadLoading">
              <i v-if="!uploadLoading" class="el-icon-upload"></i>{{ uploadLoading ? '上传中...' : '上传PDF文件' }}
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="checkDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="uploadLoading" @click="submitCheck">确认提交</el-button>
      </div>
    </el-dialog>

    <!-- 重提检查单弹窗 -->
    <el-dialog
      class="check-dialog"
      title="重提检查单"
      :visible.sync="reSubmitCheckDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" size="small">
        <el-form-item label="原检查单日期:">
          <span>{{ currentResubmitCheckDate }}</span>
        </el-form-item>
        <el-form-item label="重新上传PDF:" required>
          <el-upload
            ref="resubmitCheckUpload"
            :before-upload="resubmitBeforeUpload"
            :on-success="resubmitHandleSuccess"
            :on-remove="resubmitHandleRemove"
            :file-list="resubmitFileList"
            :limit="1"
            accept=".pdf"
            :disabled="resubmitUploadLoading"
          >
            <el-button size="small" type="primary" :disabled="resubmitUploadLoading">
              <i v-if="!resubmitUploadLoading" class="el-icon-upload"></i>{{ resubmitUploadLoading ? '上传中...' : '上传PDF文件' }}
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="reSubmitCheckDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="resubmitUploadLoading" @click="submitResubmitCheck">确认提交</el-button>
      </div>
    </el-dialog>

    <!-- 导出弹窗 -->
    <el-dialog
      title="导出批次文件"
      :visible.sync="dialogExportVisible"
      width="420px"
      :close-on-click-modal="false"
      class="export-dialog"
      custom-class="export-dialog-wrapper"
    >
      <div class="export-dialog-body">
        <el-form label-width="90px" class="export-form">
          <el-form-item label="批次号" :required="exportFlag !== '3'" v-if="exportFlag !== '3'">
            <el-input
              v-model="exportFileName"
              placeholder="请输入批次号，如：1、2、3"
              clearable
              maxlength="20"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="批次月份" required>
            <el-date-picker
              v-model="exportDate"
              type="month"
              placeholder="选择年月"
              value-format="yyyy-MM"
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeExport()">
          <i class="el-icon-close"></i> 关闭
        </el-button>
        <el-button size="small" type="primary" @click="expZipBtn()">
          <i class="el-icon-download"></i> 导 出
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageQuery, channelDict, expZip } from "@/api/system/channel";
import { saveCheckDate, deleteFileById } from "@/api/system/linXuanChannel/linXuanChannel";
import { SYS_APi_SCREENING_URL } from '@/utils/globals';
import axios from 'axios';

/**
 * 审核状态列表（与后端 auditState 中文值对应）
 */
const auditStateList = [
  { value: 'draft', label: '待提交' },
  { value: 'reviewing', label: '审核中' },
  { value: 'approve', label: '已通过' },
  { value: 'reject', label: '已驳回' }
];

export default {
  name: "channelList",
  data() {
    return {
      tableLoading: false,
      tableData: [],
      tableHeight: 400,
      paginationKey: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: { channelId: '', saleModel: '', isPublicityDate: '', isCheckDate: '', isJoinDate: '', isExitDate: '', auditState: '', timeField: '', startTime: '', endTime: '' },
      channelList: [],
      auditStateList: auditStateList,
      // 提测检查单
      checkDialogVisible: false,
      currentCheckChannelId: '',
      checkDate: '',
      fileId: '',
      fileList: [],
      uploadLoading: false,
      // 重提检查单
      reSubmitCheckDialogVisible: false,
      currentResubmitCheckChannelId: '',
      currentResubmitCheckDate: '',
      resubmitFileId: '',
      resubmitFileList: [],
      resubmitUploadLoading: false,
      chunkSize: 9 * 1024 * 1024,
      uploadUrl: '/file/uploadChunk',
      // 导出
      dialogExportVisible: false,
      exportFileName: '',
      exportFlag: '',
      exportDate: (() => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      })(),
    };
  },
  created() {
    // 加载渠道下拉字典
    channelDict().then(res => {
      if (res && res.code === '200') {
        this.channelList = res.data || [];
      }
    }).finally(() => {
      // 从路由 query 恢复搜索条件（返回列表时保留）
      const query = this.$route.query
      if (query.channelId)   this.searchForm.channelId = query.channelId || ''
      if (query.saleModel)   this.searchForm.saleModel = query.saleModel || ''
      if (query.isPublicityDate)   this.searchForm.isPublicityDate = query.isPublicityDate || ''
      if (query.isCheckDate)   this.searchForm.isCheckDate = query.isCheckDate || ''
      if (query.isJoinDate)   this.searchForm.isJoinDate = query.isJoinDate || ''
      if (query.isExitDate)   this.searchForm.isExitDate = query.isExitDate || ''
      if (query.auditState)   this.searchForm.auditState = query.auditState || ''
      if (query.timeField)    this.searchForm.timeField = query.timeField
      if (query.startTime)    this.searchForm.startTime = query.startTime
      if (query.endTime)      this.searchForm.endTime = query.endTime
      if (query.currentPage)  this.currentPage = parseInt(query.currentPage) || 1
      if (query.pageSize)     this.pageSize    = parseInt(query.pageSize)    || 10
      this.fetchList();
    });
  },
  mounted() {
    this.setTableHeight();
    window.addEventListener('resize', this.setTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight);
  },
  methods: {
    /**
     * 获取渠道列表（分页）
     */
    fetchList() {
      this.tableLoading = true;
      pageQuery({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        channelId: this.searchForm.channelId,
        saleModel: this.searchForm.saleModel,
        isPublicityDate: this.searchForm.isPublicityDate,
        isCheckDate: this.searchForm.isCheckDate,
        isJoinDate: this.searchForm.isJoinDate,
        isExitDate: this.searchForm.isExitDate,
        status: this.searchForm.auditState,
        timeField: this.searchForm.timeField,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime
      })
        .then(res => {
          if (res && res.code === '200') {
            this.total = res.data.total || 0;
            this.paginationKey = `${this.currentPage}-${this.pageSize}-${this.total}`;
            this.tableData = res.data.records || [];
          } else {
            this.$message.error(res && res.message ? res.message : '查询失败');
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          this.$message.error('查询失败，请稍后重试');
          this.tableData = [];
          this.total = 0;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    onSearch() {
      this.currentPage = 1;
      this.fetchList();
    },

    onReset() {
      this.searchForm = { channelId: '', auditState: '', timeField: '', startTime: '', endTime: '' };
      this.onSearch();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchList();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchList();
    },

    handleView(row) {
      this.$router.push({
        path: '/sys/adminChannel/view/' + row.channelId,
        query: {
          channelId: this.searchForm.channelId || '',
          auditState: this.searchForm.auditState || '',
          timeField: this.searchForm.timeField || '',
          startTime: this.searchForm.startTime || '',
          endTime: this.searchForm.endTime || '',
          saleModel: this.searchForm.saleModel || '',
          isPublicityDate: this.searchForm.isPublicityDate || '',
          isCheckDate: this.searchForm.isCheckDate || '',
          isJoinDate: this.searchForm.isJoinDate || '',
          isExitDate: this.searchForm.isExitDate || '',
          from: 'list',
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      });
    },

    handleCheck(row) {
      this.currentCheckChannelId = row.channelId;
      this.checkDialogVisible = true;
      this.checkDate = '';
      this.fileId = '';
      this.fileList = [];
    },

    handleResubmitCheck(row) {
      this.currentResubmitCheckChannelId = row.channelId;
      this.currentResubmitCheckDate = row.checkDate;
      this.resubmitFileId = '';
      this.resubmitFileList = [];
      this.resubmitUploadLoading = false;
      this.reSubmitCheckDialogVisible = true;
    },

    resubmitBeforeUpload(file) {
      const fileSuffix = file.name.split(".").pop().toLowerCase();
      if (fileSuffix !== "pdf") {
        this.$message.error(`只允许上传.pdf格式的文件！`);
        return false;
      }
      this.resubmitUploadLoading = this.$loading({
        lock: true,
        text: '文件上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.resubmitChunkedUpload(file);
      return false;
    },

    // 分块上传（重提检查单）
    async resubmitChunkedUpload(file) {
      const uploadId = Date.now();
      const fileSize = file.size / (1024 * 1024);
      const expiration = this.$store.state.expiration;
      const target = new Date(expiration).getTime();
      const diffMs = target - uploadId;
      const minutes = Math.floor(diffMs / (1000 * 60));

      if (fileSize > 500 && 10 > minutes) {
        this.$message.error('文件过大，token即将过期，无法支持完成上传，请重新登录后上传');
        this.closeResubmitLoading();
        return;
      }
      const totalChunks = Math.ceil(file.size / this.chunkSize);
      let start = 0;
      let end = this.chunkSize;
      let chunkIndex = 0;
      let uploadedChunks = 0;
      this.updateResubmitLoadingText(`正在上传 0/${totalChunks}...`);
      while (start < file.size) {
        const chunk = file.slice(start, end);
        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('fileName', file.name);
        formData.append('uploadType', 'channel_check');
        formData.append('uploadId', uploadId);
        formData.append('chunkIndex', chunkIndex);
        formData.append('totalChunks', totalChunks);

        try {
          const response = await this.uploadChunk(formData);
          if (response.data.code !== '200') {
            this.$message.error(`文件上传失败: ${response.data.message}`);
            this.closeResubmitLoading();
            break;
          }
          uploadedChunks++;
          const progress = Math.round((uploadedChunks / totalChunks) * 100);
          this.updateResubmitLoadingText(`正在上传 ${uploadedChunks}/${totalChunks} (${progress}%)`);

          if (chunkIndex === totalChunks - 1) {
            this.resubmitHandleSuccess(response, file, this.resubmitFileList);
            this.$message.success('文件上传完成');
            this.closeResubmitLoading();
          }
          start = end;
          end = Math.min(end + this.chunkSize, file.size);
          chunkIndex++;
        } catch (err) {
          console.error('上传失败:', err);
          this.$message.error(`文件上传失败: ${err.message}`);
          this.closeResubmitLoading();
          break;
        }
      }
    },

    closeResubmitLoading() {
      if (this.resubmitUploadLoading) {
        this.resubmitUploadLoading.close();
        this.resubmitUploadLoading = null;
      }
    },

    updateResubmitLoadingText(text) {
      if (this.resubmitUploadLoading) {
        this.resubmitUploadLoading.setText(text);
      }
    },

    resubmitHandleSuccess(response, file, fileList) {
      try {
        if (!response || !response.data) {
          throw new Error('服务器响应数据为空');
        }
        const fileId = response.data.data;
        if (!fileId) {
          throw new Error('无法获取文件ID');
        }
        this.resubmitFileId = fileId;
        this.resubmitFileList.push({
          name: file.name,
          url: `${SYS_APi_SCREENING_URL}/file/download/${fileId}`,
        });
      } catch (err) {
        this.resubmitFileId = "";
        this.$message.error(`上传成功但处理响应失败: ${err.message}`);
      }
    },

    resubmitHandleRemove(file, fileList) {
      this.resubmitFileList = fileList;
      if (this.resubmitFileId) {
        deleteFileById({ fileId: this.resubmitFileId }).then((res) => {
          if (res.code == 200) {
            this.$message({ type: "success", message: "上传删除成功!" });
          } else {
            this.$message.error(res.message);
          }
        });
      }
      this.resubmitFileId = '';
    },

    submitResubmitCheck() {
      if (!this.resubmitFileId) {
        this.$message.error('请上传检查单附件');
        return;
      }
      const loading = this.$loading({ lock: true, text: '提交中...', spinner: 'el-icon-loading', background: 'rgba(0,0,0,0.7)' });
      saveCheckDate({ fileId: this.resubmitFileId, date: this.currentResubmitCheckDate, channleIds: this.currentResubmitCheckChannelId })
        .then(res => {
          if (res.code === '200') {
            this.$message.success('提交成功');
            this.reSubmitCheckDialogVisible = false;
            this.fetchList();
          } else {
            this.$message.error(res.message || '提交失败');
          }
        })
        .catch(() => {
          this.$message.error('提交失败，请稍后重试');
        })
        .finally(() => {
          loading.close();
        });
    },

    // 在文件上传之前拆分成多个块
    beforeUpload(file) {
      const allowedType = "pdf";
      const fileSuffix = file.name.split(".").pop().toLowerCase();
      if (fileSuffix !== allowedType) {
        this.$message.error(`只允许上传.pdf格式的压缩包文件！`);
        return false;
      }
      this.uploadLoading = this.$loading({
        lock: true,
        text: '文件上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.chunkedUpload(file);
      return false; // 取消默认的上传
    },

    // 分块上传
    async chunkedUpload(file) {
      const uploadId = Date.now();
      //文件大小
      //登录过期时间
      const fileSize=file.size/(1024 * 1024);
      const expiration=this.$store.state.expiration;
      const target = new Date(expiration).getTime()
      // 计算差值（毫秒）
      const diffMs = target-uploadId
      const minutes=Math.floor(diffMs / (1000*60))

      if(fileSize>500 && 10>minutes){
        this.$message.error('文件过大,token即将过期，无法支持完成上传，请重新登录后上传');
        this.closeLoading();
        return;
      }
      const totalChunks = Math.ceil(file.size / this.chunkSize);  // 计算总块数
      let start = 0;
      let end = this.chunkSize;
      let chunkIndex = 0;
      let uploadedChunks = 0; // 记录已上传块数
      // 更新 loading 文字
      this.updateLoadingText(`正在上传 0/${totalChunks}...`);
      // 上传每个块
      while (start < file.size) {
        const chunk = file.slice(start, end);
        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('fileName', file.name);
        // 渠道申报：channel_insert、渠道退出：channel_quit、新增、修改商户/门店：merchant_insert、商户/门店退出：merchant_quit
        formData.append('uploadType', 'channel_check');
        formData.append('uploadId', uploadId);
        formData.append('chunkIndex', chunkIndex); // 当前块的索引
        formData.append('totalChunks', totalChunks); // 总块数

        try {
          const response = await this.uploadChunk(formData); // 上传当前块
          console.log(response);
          if(response.data.code!=='200'){
            this.$message.error(`文件上传失败: ${response.data.message}`);
            this.closeLoading();
            break;
          }
          uploadedChunks++;
          // 更新进度
          const progress = Math.round((uploadedChunks / totalChunks) * 100);
          this.updateLoadingText(`正在上传 ${uploadedChunks}/${totalChunks} (${progress}%)`);

          if (chunkIndex === totalChunks - 1) {
            // 如果是最后一块，上传完成后显示信息
            this.handleSuccess(response, file, this.fileList);
            this.$message.success('文件上传完成');
            this.closeLoading();
          }
          start = end;
          end = Math.min(end + this.chunkSize, file.size);
          chunkIndex++;
        } catch (err) {
          console.error('上传失败:', err);
          this.$message.error(`文件上传失败: ${err.message}`);
          this.closeLoading();
          break;
        }
      }
    },
    closeLoading() {
      if (this.uploadLoading) {
        this.uploadLoading.close();
        this.uploadLoading = null;
      }
    },
    // 更新 loading 文字
    updateLoadingText(text) {
      if (this.uploadLoading) {
        this.uploadLoading.setText(text);
      }
    },
    // 上传每个文件块
    uploadChunk(formData) {
      return new Promise((resolve, reject) => {
        axios.post(SYS_APi_SCREENING_URL + this.uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          resolve(response);  // 返回响应给调用者
        }).catch(error => {
          console.error('请求失败:', error);
          reject(error);
        });
      });
    },
    handleSuccess(response, file, fileList) {
      try {
        // 检查响应数据结构
        if (!response || !response.data) {
          throw new Error('服务器响应数据为空');
        }
        const fileId = response.data.data;
        if (!fileId) {
          throw new Error('无法获取文件ID');
        }
        this.fileId = fileId;
        console.log('文件ID:', fileId);
        this.fileList.push({
          name: file.name,
          url: `${SYS_APi_SCREENING_URL}/file/download/${fileId}`,
        });
      } catch (err) {
        this.fileId = "";
        this.$message.error(`上传成功但处理响应失败: ${err.message}`);
        console.error('处理上传响应失败:', err);
      }
    },
    handleError(error, file, fileList) {
      this.fileId = "";
      console.log('上传失败', error);
    },
    handleRemove(file, fileList) {
      if(this.fileId==""){
        const fileId = this.fileId;
        if (fileId) {
          deleteFileById({fileId: fileId}).then((res) => {
            if (res.code == 200) {
              this.fileList = fileList.filter(item => item.name !== file.name);
              this.$message({
                type: "success",
                message: "上传删除成功!",
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }
      }else{
        this.fileList=[];
      }
    },

    submitCheck() {
      if (!this.checkDate) {
        this.$message.error('请选择检查单日期');
        return;
      }
      console.log("文件Id", this.fileId)
      if (!this.fileId) {
        this.$message.error('请上传检查单附件');
        return;
      }
      const loading = this.$loading({ lock: true, text: '提交中...', spinner: 'el-icon-loading', background: 'rgba(0,0,0,0.7)' });
      saveCheckDate({ fileId: this.fileId, date: this.checkDate, channleIds: this.currentCheckChannelId })
        .then(res => {
          if (res.code === '200') {
            this.$message.success('提交成功');
            this.checkDialogVisible = false;
            this.fetchList();
          } else {
            this.$message.error(res.message || '提交失败');
          }
        })
        .catch(() => {
          this.$message.error('提交失败，请稍后重试');
        })
        .finally(() => {
          loading.close();
        });
    },

    exportExcel(flag) {
      this.exportFlag = flag;
      this.exportFileName = '';
      const d = new Date();
      this.exportDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      this.dialogExportVisible = true;
    },

    closeExport() {
      this.dialogExportVisible = false;
      this.exportFileName = '';
      this.exportFlag = '';
      const d = new Date();
      this.exportDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    },

    expZipBtn() {
      if (this.exportFlag !== '3' && !this.exportFileName.trim()) {
        this.$message({ message: '请输入批次号！', type: 'warning' });
        return;
      }
      if (!this.exportDate) {
        this.$message({ message: '请选择批次月份！', type: 'warning' });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const nameMap = { '1': '公示.zip', '2': '通知.zip', '3': '全量.zip' };
      expZip({ exportFileName: this.exportFileName, exportFlag: this.exportFlag, exportDate: this.exportDate })
        .then(res => {
          const blob = new Blob([res]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = nameMap[this.exportFlag] || 'export.zip';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          this.$message.success('导出成功');
          this.dialogExportVisible = false;
        })
        .catch(() => {
          this.$message.error('导出失败，请稍后重试');
        })
        .finally(() => {
          loading.close();
        });
    },

    getAuditStateColor(state) {
      if (!state) return '#333';
      const map = {
        '待提交': '#909399',
        '审核中': '#E6A23C',
        '已通过': '#67C23A',
        '初审驳回': '#F56C6C',
        '复审驳回': '#F56C6C'
      };
      return map[state] || '#333';
    },

    formatAuditDesc(row) {
      return row.auditDesc || '';
    },

    setTableHeight() {
      this.$nextTick(() => {
        if (typeof window !== 'undefined') {
          const clientHeight = window.innerHeight || document.documentElement.clientHeight;
          this.tableHeight = Math.round(clientHeight * 0.58) - 140;
        }
      });
    }
  }
};
</script>

<style scoped>
.flex-container { height: 100%; display: flex; flex-direction: column; text-align: left; }
.flex-header { flex-shrink: 0; background: #fff; padding-bottom: 12px; }
.search-form { margin-bottom: 16px; }
.flex-item { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.table-wrapper { flex: 1; min-height: 0; overflow: hidden; }
.pagination-bar { text-align: right; padding: 8px 0; flex-shrink: 0; }

/* 提测检查单弹窗 */
.check-dialog >>> .el-dialog__body {
  padding: 20px 24px;
}
.check-dialog >>> .el-dialog__footer {
  padding: 12px 24px 16px;
  border-top: 1px solid #ebeef5;
}
.upload-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #f5f7fa;
  border-radius: 4px;
}
.upload-tip i {
  color: #409EFF;
}

/* 导出弹窗 */
.export-dialog >>> .el-dialog {
  border-radius: 8px;
  overflow: hidden;
}
.export-dialog >>> .el-dialog__header {
  padding: 18px 20px 14px;
  border-bottom: 1px solid #ebeef5;
  background: #fafbfc;
}
.export-dialog >>> .el-dialog__title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.export-dialog >>> .el-dialog__body {
  padding: 24px 20px;
}
.export-dialog >>> .el-dialog__footer {
  padding: 12px 20px 16px;
  border-top: 1px solid #ebeef5;
}
.export-form .el-form-item {
  margin-bottom: 18px;
}
.export-form .el-form-item:last-child {
  margin-bottom: 0;
}
.export-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}
.export-dialog .dialog-footer {
  text-align: center;
  padding: 4px 0;
}
.export-dialog .dialog-footer .el-button {
  min-width: 80px;
  margin: 0 6px;
  border-radius: 4px;
}
/* 审核状态双元素 */
.audit-state-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
/* 审核意见弹出区样式 */
.audit-tip-plain {
  max-width: 500px;
  max-height: 240px;
  padding: 5px 8px;
  overflow-y: auto;
  line-height: 1.6;
  color: #303133;
  font-size: 12px;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;
}
.audit-tip-plain::-webkit-scrollbar { width: 6px; }
.audit-tip-plain::-webkit-scrollbar-thumb { background: #dcdfe6; border-radius: 3px; }
.audit-tip-plain::-webkit-scrollbar-track { background: #f5f7fa; border-radius: 3px; }
.audit-tooltip-popper {
  background: #ffffff !important;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
</style>
